export default {
    xmppCreds(state) {
        return state.xmppCreds;
    },
};
